import React from 'react';
import { Tag } from 'antd';
import { STATUS_COLORS, STATUS_LABELS } from '../../../utils/constants';

/**
 * Props do componente StatusTag.
 */
interface StatusTagProps {
  status: string;
}

/**
 * Componente Tag padronizado para exibir status.
 * 
 * Usa cores e labels padronizados baseados no status.
 * 
 * @param status - Status a ser exibido
 */
export const StatusTag: React.FC<StatusTagProps> = ({ status }) => {
  const color = STATUS_COLORS[status.toLowerCase()] || 'default';
  const label = STATUS_LABELS[status.toLowerCase()] || status;

  return (
    <Tag color={color}>
      {label.toUpperCase()}
    </Tag>
  );
};

export default StatusTag;

